import ContratosTablaActions from "@/pages/Clientes/Contratos/Tabla/ContratosTablaActions";
import { get } from "lodash-es";
import moment from "moment";
import referenciaDeColoresComponent from "./referenciaDeColoresComponent.vue";

export default {
  components: {
    ContratosTablaActions,
    referenciaDeColoresComponent,
  },
  beforeMount() {
    // mounted() {
    this.statusBar = {
      statusPanels: [
        {
          statusPanel: "agTotalAndFilteredRowCountComponent",
          align: "left",
        },
        {
          statusPanel: "agTotalRowCountComponent",
          align: "center",
        },

        {
          statusPanel: "referenciaDeColoresComponent",
          align: "right",
        },

        { statusPanel: "agFilteredRowCountComponent" },
        { statusPanel: "agSelectedRowCountComponent" },
        { statusPanel: "agAggregationComponent" },
      ],
    };

    this.defaultColDef = {
      wrapHeaderText: true,
      autoHeaderHeight: true,
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
      minWidth: 100,
    };
  },
  data: () => ({
    quickFilter: "",
    gridApi: null,
    columnApi: null,
    defaultColDef: null,
    statusBar: null,
    // api: null,
    columnDefs: [
      {
        headerName: "ID Contrato",
        field: "id_contrato",
        wrapHeaderText: true,
        autoHeaderHeight: true,

        filter: false,
        sort: "asc",
        minWidth: 150,
        comparator: (a, b) => {
          const numA = parseInt(a);
          const numB = parseInt(b);
          return numA - numB;
        },
        hide: true,
      },
      {
        headerName: "Patente",
        field: "patente",
        minWidth: 120,
      },
      {
        headerName: "Alias",
        field: "dominio",
        minWidth: 120,
      },
      {
        headerName: "Relay",
        field: "relay",
        maxWidth: 90,
        hide: true,
      },
      {
        headerName: "Avl",
        field: "id_avl",
        maxWidth: 90,
      },
      {
        headerName: "Modelo de AVL",
        field: "modelo",
        minWidth: 110,
      },
      {
        headerName: "Chip",
        field: "id_chip",
        maxWidth: 90,
        hide: true,
      },
      {
        headerName: "Empresa",
        field: "empresa",
        minWidth: 120,
        hide: true,
      },
      {
        headerName: "Imei",
        field: "imei",
        minWidth: 160,
      },
      {
        headerName: "Fecha alta",
        field: "fecha_alta",
        minWidth: 120,
        valueGetter: (params) =>
          moment(params.data.fecha_alta).format("DD-MM-YYYY"),
      },
      {
        headerName: "Ubicación AVL",
        field: "ubicacion",
        minWidth: 150,
        autoHeight: true,
        wrapText: true,
      },
      {
        headerName: "Chip Numero",
        field: "numero",
        minWidth: 150,
      },
      {
        headerName: "Tipo Contrato",
        field: "nombre_contrato",
        minWidth: 200,
      },
      {
        headerName: "Actions",
        cellRendererFramework: ContratosTablaActions,
        cellStyle: { backgroundColor: "white!important" },
      },
    ],
  }),
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.getContratos();
    },
    async getContratos() {
      this.gridApi.showLoadingOverlay();
      const resp = await this.$store.dispatch(
        "Contratos/getContratos",
        this.clienteId,
      );
      if (get(resp, "ok", true) == false) {
        this.$msgBoxOk(get(resp, "message", "Ocurrio un error")); //
      }
      this.gridApi.hideOverlay();
    },
    getRowStyle(params) {
      if (params.data.fecha_inicio) {
        if (params.data.fecha_fin) {
          if (moment(params.data.fecha_fin).diff(moment()) > 0) {
            return { backgroundColor: "#C6E8FB" };
          } else {
            return {};
          }
        }
        return { backgroundColor: "#8FD3F7" };
      } else {
        return {};
      }
    },
  },
  watch: {
    quickFilter(val) {
      this.gridApi.setQuickFilter(val);
    },
  },
  computed: {
    rowData() {
      return get(this.$store, "state.Contratos.contratos", []);
    },
  },
};
